var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.tableData.COURSES_NOT_IN_PROGRESS.length > 0
        ? _c(
            "div",
            { staticClass: "table-responsive" },
            [
              _c(
                "table-editable-list",
                {
                  attrs: {
                    columns: _vm.departmentColumnsConfig,
                    "show-select": false,
                    "show-actions": false
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "data-row" },
                    [
                      _vm._l(_vm.tableData.COURSES_NOT_IN_PROGRESS, function(
                        course,
                        courseIdx
                      ) {
                        return [
                          _c("table-list-row", {
                            key:
                              "course_not_in_progress_" +
                              course.COURSE_ID +
                              "_" +
                              courseIdx,
                            attrs: {
                              columns: _vm.departmentColumnsConfig,
                              rowdata: course,
                              rowIndex: courseIdx,
                              showActions: false
                            }
                          })
                        ]
                      })
                    ],
                    2
                  )
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tableData.COURSES_IN_PROGRESS.length > 0
        ? [
            _c("div", { attrs: { tabindex: "0" } }, [
              _c("i", [
                _vm._v(
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.ProgressReportDepartments.inProgress")
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-responsive" },
              [
                _c(
                  "table-editable-list",
                  {
                    attrs: {
                      columns: _vm.departmentColumnsConfig,
                      "show-select": false,
                      "show-actions": false
                    }
                  },
                  [
                    _c(
                      "template",
                      { slot: "data-row" },
                      [
                        _vm._l(_vm.tableData.COURSES_IN_PROGRESS, function(
                          course,
                          courseIdx
                        ) {
                          return [
                            _c("table-list-row", {
                              key:
                                "course_in_progress-" +
                                course.COURSE_ID +
                                "_" +
                                courseIdx,
                              attrs: {
                                columns: _vm.departmentColumnsConfig,
                                rowdata: course,
                                rowIndex: courseIdx,
                                showActions: false
                              }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ],
                  2
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.tableData.COURSES_NOT_IN_PROGRESS.length === 0 &&
      _vm.tableData.COURSES_IN_PROGRESS.length === 0
        ? [
            _c("div", { staticClass: "row", attrs: { tabindex: "0" } }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.ProgressReportDepartments.noCoursesQualifyRequirementWithPeriod"
                      )
                    ) +
                    "\n\t\t\t"
                )
              ])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }